import { initializeApp } from 'firebase/app'
import {
  connectFirestoreEmulator,
  doc,
  initializeFirestore,
} from 'firebase/firestore'

import { installFirestoreConnectionWatchdog } from './firebase-firestore-watchdog'
import firebaseConfig, { getFirebaseLocalHost } from './firebaseConfig'

const app = initializeApp(firebaseConfig)

const firestore = initializeFirestore(app, {
  experimentalForceLongPolling: true,
})

const { firebasePort, firebaseIp } = getFirebaseLocalHost()

if (firebasePort && firebaseIp) {
  connectFirestoreEmulator(
    firestore,
    firebaseIp || 'localhost',
    Number(firebasePort)
  )
}

if (typeof window !== 'undefined') {
  installFirestoreConnectionWatchdog(firestore, {
    healthCheckRef: doc(firestore, 'session-base', 'map'),
  })
}

export default firestore
